import { supabase } from '../supabaseClient';

const CONTEXT_COLUMNS = 'doc_id, goal_state, source_fingerprint, created_at, updated_at';
const PRIMARY_CONTEXT_TABLE = 'doc_context';
const LEGACY_CONTEXT_TABLE = 'chat_context';

const isMissingRelationError = (error, tableName = '') => {
  const code = String(error?.code || '').trim();
  const message = String(error?.message || '').toLowerCase();
  const target = String(tableName || '').trim().toLowerCase();
  return code === '42P01' || (message.includes('relation') && (!target || message.includes(target)));
};

const normalizeContextRow = (data) => {
  if (!data) return null;
  return {
    docId: Number(data.doc_id),
    goalState: data.goal_state && typeof data.goal_state === 'object' ? data.goal_state : null,
    sourceFingerprint: typeof data.source_fingerprint === 'string' ? data.source_fingerprint : null,
    createdAt: data.created_at || null,
    updatedAt: data.updated_at || null
  };
};

export async function apiLoadChatContext({ docId } = {}) {
  const normalizedDocId = Number(docId);
  if (!Number.isFinite(normalizedDocId) || normalizedDocId <= 0) return null;

  const loadFromTable = async (tableName) => {
    const { data, error } = await supabase
      .from(tableName)
      .select(CONTEXT_COLUMNS)
      .eq('doc_id', normalizedDocId)
      .maybeSingle();

    if (error) {
      if (isMissingRelationError(error, tableName)) return null;
      throw error;
    }

    return data || null;
  };

  let row = await loadFromTable(PRIMARY_CONTEXT_TABLE);
  if (!row) {
    row = await loadFromTable(LEGACY_CONTEXT_TABLE);
  }

  return normalizeContextRow(row);
}

export async function apiUpsertChatContext({
  docId,
  goalState,
  sourceFingerprint = null
} = {}) {
  const normalizedDocId = Number(docId);
  if (!Number.isFinite(normalizedDocId) || normalizedDocId <= 0) return null;

  const payload = {
    doc_id: normalizedDocId,
    goal_state: goalState && typeof goalState === 'object' ? goalState : {},
    source_fingerprint: typeof sourceFingerprint === 'string' && sourceFingerprint.trim()
      ? sourceFingerprint
      : null,
    updated_at: new Date().toISOString()
  };

  const upsertTable = async (tableName) => {
    const { data, error } = await supabase
      .from(tableName)
      .upsert([payload], { onConflict: 'doc_id' })
      .select(CONTEXT_COLUMNS)
      .maybeSingle();

    if (error) {
      if (isMissingRelationError(error, tableName)) return null;
      throw error;
    }

    return data || null;
  };

  let row = await upsertTable(PRIMARY_CONTEXT_TABLE);
  if (!row) {
    row = await upsertTable(LEGACY_CONTEXT_TABLE);
  }

  return normalizeContextRow(row);
}
